import React, { Component } from 'react';

import Slider from './Slider/Slider';
import Benefits from './Benefits/Benefits';
import WhyFly from './WhyFly/WhyFly';
import ScrollContainer from '@components/ScrollContainer/ScrollContainer';
import BackgroundTextBox from '@components/BackgroundTextBox/BackgroundTextBox';
import Helmet from 'react-helmet';
//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

//import { Link } from 'react-router-dom';
//import { ModalBody, Modal } from 'reactstrap';
import Css from './Home.scss';

import ImportImages from '@src/importImages';
const ExperienceBackground = ImportImages('/home/home-experiences.jpg');
//const Promo = ImportImages('/promotion/experiences.jpg');

class Home extends Component {
  componentDidMount = () => {
    document.title =
      'JetSuite | Private Jet Charter Flights – Private Jet Rental Service';
  };

  render() {
    const benefitsProps = {
      id: 'home-benefits',
      screenHeight: this.props.pageHeight,
      className: 'panel d-flex align-items-center justify-content-center',
      header: 'A Breath Of Fresh Air',
      content:
        'In the world of private aviation, JetSuite does it differently. This is light-jet travel for the dreamers' +
        ' and visionaries who carve their own independent paths. JetSuite, like you, is dedicated to a better way' +
        " forward, moving people — and the light jet industry — into new, uncharted territories. It's where the" +
        ' spirit of hospitality takes flight.',
      link: {
        url: '/suitekey-membership',
        label: 'Become A Member'
      },
      style: {
        width: this.props.pageWidth < 992 ? 'auto' : '618px'
      }
    };
    let height = window.innerHeight;
    const experiencesProps = {
      id: 'home-experiences',
      screenHeight: height,
      className: 'panel d-flex flex-column align-items-center',
      header: 'JetSuite Experiences',
      content:
        '“JetSuite Experiences” is a first of its kind in business aviation, dedicated to creating' +
        ' thoughtfully-designed experiences that go beyond a destination.',
      style: {
        width: '600px'
      },
      link: {
        url: '/jetsuite-experiences',
        label: 'Learn More',
        onClick: () => {
          window.gtag('event', 'click', {
            event_category: 'JS-Experiences-Engagement',
            event_label: 'Homepage JetSuite Experience Frame CTA'
          });
        }
      },
      backgroundImage: ExperienceBackground
    };

    const propsContainer = {};
    if (window.location.pathname === '/about-us') {
      propsContainer.autoScroll = {
        active: 1,
        delay: 1000
      };
    } else if (window.location.hash === '#exclusive') {
      propsContainer.autoScroll = {
        active: 3,
        delay: 1000
      };
    }

    return (
      <React.Fragment>
        <Helmet>
          <title>
            JetSuite | Private Jet Charter Flights – Private Jet Rental Service
          </title>
          <meta
            name="description"
            content={
              'In the world of private aviation, JetSuite does it differently. This is light-jet travel for the dreamers and visionaries who carve their own independent paths.'
            }
          />
        </Helmet>
        <ScrollContainer pageHeight={this.props.pageHeight} {...propsContainer}>
          <Slider
            sliderImg={this.props.sliderImg}
            screenHeight={this.props.pageHeight}
            className={'panel d-flex align-items-center justify-content-center'}
            id={'home-slider'}
          />
          <Benefits {...benefitsProps} />
          <WhyFly
            screenHeight={this.props.pageHeight}
            className={Css.home + ' panel d-flex align-items-center'}
            heightSm={this.props.heightSm}
            id={'home-whyfly'}
          />
          <BackgroundTextBox {...experiencesProps} />
        </ScrollContainer>
        {/*<Modal
          isOpen={
            this.props.modalActive && window.location.hash !== '#exclusive'
          }
          toggle={this.props.toggleModal}
          className={
            'modal-lg h-100 d-flex flex-column justify-content-center my-0'
          }
        >
          <ModalBody style={{ backgroundColor: '#eeeeee' }} className={'p-0'}>
            <div className={'position-relative'}>
              <img src={Promo} className={'img-fluid'} alt={'Promotion'} />
            </div>
            <div
              style={{
                color: 'white',
                position: 'absolute',
                top: '5px',
                right: '7px'
              }}
              onClick={this.props.toggleModal}
            >
              <FontAwesomeIcon
                icon={['fas', 'times']}
                className={'pointer font-lg'}
              />
            </div>
            <div className="p-3 text-center">
              JetSuite Experiences have arrived - go beyond the destination with
              thoughtfully designed experiences.
              <br />
              <Link
                to="/jetsuite-experiences"
                className={'btn btn-default mt-2 mb-3'}
                onClick={() => {
                  window.gtag('event', 'click', {
                    event_category: 'JS-Experiences-Engagement',
                    event_label: 'Homepage Pop Up CTA - JetSuite Experiences'
                  });
                }}
              >
                Learn More
              </Link>
            </div>
          </ModalBody>
        </Modal>*/}
      </React.Fragment>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home/Home.js